<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>

    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
      :key="counter"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[600px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["clients_register_text_105"] }}
          </label>
          <BaseInputNew
            @keyupEnter="loadData()"
            inputClass="tw-app-input-dark"
            @input="
              (e) =>
                fillFilter({
                  value: e.value,
                  name: 'OR',
                  type: 'input',
                })
            "
          />
        </div>
        <div class="tw-flex tw-flex-row">
          <button type="button" class="tw-app-btn-primary" @click="loadData(1)">
            {{ dataLang["clients_register_text_106"] }}
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px] tw-mt-[15px]">
      <div class="tw-flex tw-gap-[10px] tw-justify-end">
        <button
          @click="toAnketa('yandexrent_security_client')"
          class="tw-app-btn-primary-outline"
        >
          {{ dataLang["clients_register_text_99"] }}
        </button>

        <button
          @click="toAnketa('base_security_client')"
          class="tw-app-btn-primary-outline"
        >
          {{ dataLang["clients_register_text_100"] }}
        </button>

        <button
          @click="acceptDelete"
          class="tw-app-btn-primary-outline tw-app-btn-lock"
        >
          <img
            :src="require(`@/assets/icons/minus-dark.svg`)"
            width="13.5"
            height="13.5"
            class="tw-my-[-5px]"
          />
          {{ dataLang["clients_register_text_84"] }}
        </button>

        <button
          @click="$modal.show('modalSmsPresets')"
          class="tw-app-btn-primary-outline"
        >
          {{ dataLang["orders_page_btn_text1"] }}
        </button>

        <button @click="onOpenSmsModal" class="tw-app-btn-primary-outline">
          {{ dataLang["orders_page_btn_text3"] }}
        </button>

        <button
          @click="toExcel"
          class="tw-app-btn-primary-outline tw-app-btn-lock"
        >
          <img
            :src="require(`@/assets/icons/to-exel.svg`)"
            width="13.5"
            height="13.5"
          />

          {{ dataLang["clients_register_text_104"] }}
        </button>
      </div>

      <div class="tw-flex tw-justify-between tw-mt-[15px]">
        <div class="tw-flex">
          <button @click="loadData()" class="tw-app-btn-primary-outline">
            {{ dataLang["register_btn_filter_on"] }}
          </button>
          <button
            @click="resetFilter()"
            class="tw-app-btn-light !tw-text-[#0056AF]"
          >
            Сбросить
          </button>
        </div>
        <TwBasePagination
          :page-count="numPages"
          :pagination-params="{
            ...paginationClientsStateParams,
            limit: limitPaginationValue,
          }"
          :showLimitInput="true"
          @updateLimitValue="updateLimitValue"
          :page-range="10"
          :margin-pages="0"
          :click-handler="loadData"
        >
        </TwBasePagination>
      </div>

      <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
        <BaseLoader v-if="localLoading"></BaseLoader>
        <ve-table
          class="rest-style-table fixed-header"
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          row-key-field-name="clients__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :checkbox-option="{
            hideSelectAll: false,
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
          }"
          v-if="!localLoading"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :rowStyleOption="{
            hoverHighlight: true,
          }"
          :cellSelectionOption="{ enable: false }"
        >
        </ve-table>
      </div>
    </div>

    <BaseModal
      name="acceptDeleteWithPin"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="pincodeModalHandler"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDeleteWithPin')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>

          <BaseInputNew
            inputClass="tw-app-input-type-3"
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDeleteWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="changeMethod(currentMethodType)"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              Выполнить
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <SmsPresetsModal :type-reestr="2" />
    <SendSomeSms />
    <ClientsModal></ClientsModal>
    <SendListPhoneSmsModal reestrName="клиентам" />
    <QuestionModal title="Как искать по дате" />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import SelectsService from "@/api/SelectsService";
import GeneralService from "@/api/GeneralService";
import SmsPresetsModal from "./orders-modal/SmsPresetsModal.vue";
import EventBus from "@/event-bus.js";
import SendSomeSms from "@/components/reuse_modal/SendSomeSms.vue";
import ClientsModal from "./clients-modal/ClientsModal.vue";
import SendListPhoneSmsModal from "@/components/reuse_modal/SendListPhoneSmsModal.vue";
import QuestionModal from "@/views/contracts-modal/QuestionModal.vue";
export default {
  components: {
    VeTable,
    SendSomeSms,
    ClientsModal,
    SmsPresetsModal,
    SendListPhoneSmsModal,
    QuestionModal,
  },

  props: {},
  data() {
    return {
      counter: 0,
      params: {
        page: 1,
      },
      pincode: "",
      messageError: [],
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      filterDateMask: "",
      filterDateMaskNextCall: "",
      updatedValues: {},
      computedAllPage: 1,
      // currentPage: 1,
      activePagePagination: {},
      currentOpenedId: null,
      mainModalOpened: false,
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.currentOpenedId = row.orders__id;
              this.$modal.show("clientsModal", {
                id: row.clients__id,
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "clients__id" && row?.settings?.clients__id)
            return row?.settings?.clients__id;
          if (column.field == "clients__phone" && row?.settings?.clients__phone)
            return row?.settings?.clients__phone;
          if (column.field == "clients__name" && row?.settings?.clients__name)
            return row?.settings?.clients__name;
          if (
            column.field == "clients__next_call_date" &&
            row?.settings?.clients__next_call_date
          )
            return row?.settings?.clients__next_call_date;
        },
      },
      limitPaginationValue: 50,
    };
  },
  methods: {
    onOpenSmsModal() {
      if (this.activeSelectRowsMultiple?.length) {
        let resultArrayListNumber = [];
        this.activeSelectRowsMultiple.forEach((acceptId) => {
          resultArrayListNumber.push(
            this.dataTable.find((x) => x.clients__id == acceptId).clients__phone
          );
        });
        this.$modal.show("sendListPhoneSmsModal", {
          numberList: [...new Set(resultArrayListNumber)],
        });
      } else {
        this.$toast.error("Не выбран(ы) клиенты");
      }
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData(1);
    },
    toAnketa(type) {
      this.localLoading = true;

      if (this.activeSelectRowsMultiple.length == 1) {
        GeneralService.editOrCreate("/anketa-security", {
          clientsIds: this.activeSelectRowsMultiple[0],
          typeSecurity: type,
        })
          .then((data) => {
            this.localLoading = false;
            this.activeSelectRowsMultiple = [];
            this.$toast.success(data.data.message);
            this.loadData(1);
          })
          .catch((e) => {
            this.activeSelectRowsMultiple = [];
            this.$toast.error(e.response.data.errors[0].message, {
              duration: 5000,
            });
            this.loadData(1);
          });
      } else if (this.activeSelectRowsMultiple.length == 0) {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
        this.localLoading = false;
      } else {
        this.$toast.error(
          "Можно отправить не более одного клиента на проверку"
        );
        this.localLoading = false;
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    changeMethod(type) {
      if (type == "delete") {
        this.acceptDelete();
      } else {
        this.toExcel();
      }
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete("/clients/" + this.activeSelectRowsMultiple, {
          ...(this.pincode && { pincode: this.pincode }),
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.loadData(1);
            this.$toast.success(data.data.message);
            this.$modal.hide("acceptDeleteWithPin");
          })
          .catch((e) => {
            if (e.response.status == 409) {
              this.currentMethodType = "delete";
              this.$modal.show("acceptDeleteWithPin", { type: "delete" });
              this.messageError = e.response.data.message;
              this.$toast.error(e.response.data.message, { duration: 5000 });
            } else if (e.response.status == 400) {
              this.messageError = e.response.data.message;
              this.$toast.error(e.response.data.message, { duration: 5000 });
              this.$modal.hide("acceptDeleteWithPin");
            }
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    toExcel() {
      GeneralService.toSpecExcel("/clients/table/active/xlsx", {
        ...(this.pincode && { pincode: this.pincode }),
      })
        .then((data) => {
          // this.selects.push(data.data.data.rows)

          this.pincode = "";
          this.$modal.hide("acceptDeleteWithPin");
          const filename = new Date().toISOString();
          const url = window.URL.createObjectURL(data.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${filename}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((e) => {
          if (e.response.status == 409) {
            this.currentMethodType = "excel";
            this.$modal.show("acceptDeleteWithPin", { type: "excel" });
            this.messageError = e.response.data.message;
          } else if (e.response.status == 400) {
            this.messageError = e.response.data.message;
            this.$modal.hide("acceptDeleteWithPin");
            this.$toast.error(e.response.data.message, { duration: 5000 });
          }
        });
    },
    loadData(page = 1) {
      this.localLoading = true;
      // this.currentPage = page;
      // удалим из фильтрации поля которые будем обрабатывать особым образом
      let filterForSend = this.filter
        .filter((i) => i.field != "clients__fiz_date_birth")
        .filter((i) => i.field != "clients__next_call_date");
      // удалим из фильтрации поля которые будем обрабатывать особым образом
      Promise.all([
        GeneralService.get("/clients/table/active", {
          params: {
            ...this.paginationClientsStateParams,
            page: page,
            limit: this.limitPaginationValue,
            ...((filterForSend.length ||
              !!this.filterDateMask ||
              !!this.filterDateMaskNextCall) && {
              where: JSON.stringify([
                ...filterForSend,
                ...(this.filterDateMask
                  ? [
                      {
                        field: "clients__fiz_date_birth",
                        value: this.filterDateMask,
                        mod: "date.mask",
                      },
                    ]
                  : []),
                ...(this.filterDateMaskNextCall
                  ? [
                      {
                        field: "clients__next_call_date",
                        value: this.filterDateMaskNextCall,
                        mod: "datetime.mask",
                      },
                    ]
                  : []),
              ]),
            }),
          },
          // ,
        })
          .then((data) => {
            this.getClientsAll(data.data.data);
            this.activePagePagination = data.data.data;
            this.computedAllPage = data.data.data.total / data.data.data.limit;
            this.dataTable = data.data.data.rows;
            this.activeSelectRowsMultiple = [];
          })
          .finally(() => {
            this.localLoading = false;
          }),
      ]).then(() => {});
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.filterDateMask = "";
      this.filterDateMaskNextCall = "";
      this.loadData(1);
      // this.$refs.globalFilter.value = "";
      if (this.$refs.birthMaskFilter) {
        this.$refs.birthMaskFilter.value = "";
      }
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });

      this.counter++;
    },
    fillFilter(data) {
      if (data.name !== "OR") {
        let newValueFilter =
          data.type == "like" ? `;percent;${data.value};percent;` : data.value;
        if (!this.filter.find((x) => x.field == data.name)) {
          this.filter.push({
            field: data.name,
            value: newValueFilter,
            ...(data.type == "like" && { operator: "like" }),
            ...(data.mod && { mod: "datetimeUTC" }),
          });
        } else {
          this.filter[
            this.filter.findIndex((x) => x.field == data.name)
          ].value = newValueFilter;
        }
      }

      if (data.name == "OR") {
        if (this.filter[this.filter.findIndex((x) => "OR" in x)]) {
          this.filter[this.filter.findIndex((x) => "OR" in x)].OR = [
            {
              field: "clients__id",
              value: `;percent;${data.value};percent;`,
              operator: "like",
            },
            {
              field: "clients__name",
              value: `;percent;${data.value};percent;`,
              operator: "like",
            },
            {
              field: "clients__phone",
              value: `;percent;${data.value};percent;`,
              operator: "like",
            },
          ];
        } else {
          this.filter.push({
            OR: [
              {
                field: "clients__id",
                value: `;percent;${data.value};percent;`,
                operator: "like",
              },
              {
                field: "clients__name",
                value: `;percent;${data.value};percent;`,
                operator: "like",
              },
              {
                field: "clients__phone",
                value: `;percent;${data.value};percent;`,
                operator: "like",
              },
            ],
          });
        }
      }
    },
    sanitizeBirthDateMask(raw) {
      // allow only digits and dots, max 2 dots, max length 10; auto-insert dots when none provided
      const cleaned = (raw || "").replace(/[^\d.]/g, "");

      // If user already typed dots, just clamp count/length
      let dots = 0;
      let out = "";
      for (const ch of cleaned) {
        if (ch === ".") {
          if (dots >= 2) continue;
          dots += 1;
          out += ch;
        } else {
          out += ch;
        }
        if (out.length >= 10) break;
      }

      // Auto-insert dots only when there are zero dots AND at least 3 digits typed (avoid early insertion after 1-2 digits)
      if (dots === 0) {
        const digits = out.replace(/\./g, "");
        if (digits.length >= 3) {
          const limited = digits.slice(0, 8);
          const parts = [];
          parts.push(limited.slice(0, 2)); // DD
          if (limited.length > 2) parts.push(limited.slice(2, 4)); // MM
          if (limited.length > 4) parts.push(limited.slice(4, 8)); // YYYY (up to 4 digits)
          return parts.filter(Boolean).join(".").slice(0, 10);
        }
      }

      return out;
    },
    setBirthDateMaskFilter(eventOrValue) {
      const raw =
        eventOrValue && eventOrValue.target
          ? eventOrValue.target.value
          : eventOrValue;
      const masked = this.sanitizeBirthDateMask(raw || "");

      // Reflect masked value back into the input for immediate feedback
      if (eventOrValue && eventOrValue.target) {
        eventOrValue.target.value = masked;
      }

      this.filterDateMask = masked;

      const idx = this.filter.findIndex(
        (x) => x.field === "clients__fiz_date_birth" && x.mod === "date.mask"
      );

      if (masked) {
        const entry = {
          field: "clients__fiz_date_birth",
          value: masked,
          mod: "date.mask",
        };
        if (idx >= 0) {
          this.filter.splice(idx, 1, entry);
        } else {
          this.filter.push(entry);
        }
      } else if (idx >= 0) {
        this.filter.splice(idx, 1);
      }
    },
    setClientsNextCallDateMaskFilter(eventOrValue) {
      const raw =
        eventOrValue && eventOrValue.target
          ? eventOrValue.target.value
          : eventOrValue;
      const masked = this.sanitizeBirthDateMask(raw || "");

      // Reflect masked value back into the input for immediate feedback
      if (eventOrValue && eventOrValue.target) {
        eventOrValue.target.value = masked;
      }

      this.filterDateMaskNextCall = masked;

      const idx = this.filter.findIndex(
        (x) =>
          x.field === "clients__next_call_date" && x.mod === "datetime.mask"
      );

      if (masked) {
        const entry = {
          field: "clients__next_call_date",
          value: masked,
          mod: "datetime.mask",
        };
        if (idx >= 0) {
          this.filter.splice(idx, 1, entry);
        } else {
          this.filter.push(entry);
        }
      } else if (idx >= 0) {
        this.filter.splice(idx, 1);
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
      this.messageError = "";
      this.currentMethodType = "";
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("clientPagiation", ["getClientsAll"]),
  },
  mounted() {
    this.currentOpenedId = 95;
    EventBus.$on("updateContentData", () => {
      this.loadData(1);
    });
    EventBus.$on("closeModal", () => {
      this.$modal.hide("clientsModal");
    });
    this.filter.push({
      OR: [
        {
          field: "clients__id",
          value: `;percent;;percent;`,
          operator: "like",
        },
        {
          field: "clients__name",
          value: `;percent;;percent;`,
          operator: "like",
        },
        {
          field: "clients__phone",
          value: `;percent;;percent;`,
          operator: "like",
        },
      ],
    });
  },
  created() {
    this.loadData(1);
    this.currentOpenedId = 95;
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("clientPagiation", ["paginationClientsStateParams"]),
    ...mapGetters("clientPagiation", ["numPages"]),
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "clients__id",
          key: "12",
          title: this.dataLang["clients_register_text_107"],
          align: "left",
          width: "5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"clients__id"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },

        {
          field: "clients__balance",
          key: "13",
          title: this.dataLang["clients_register_text_108"],
          align: "left",
          width: "5%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.clients__balance.replace(".", ",")}</span>;
          },
        },
        {
          field: "clients__name",
          key: "14",
          title: this.dataLang["clients_register_text_109"],
          align: "left",
          width: "10%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"clients__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "clients__fiz_date_birth",
          key: "15",
          title: this.dataLang["clients_register_text_110"],
          align: "left",
          width: "8%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center d-flex gap-5 align-items-center"}>
                  {column.title}{" "}
                  <img
                    onClick={() =>
                      this.$modal.show("questionModal", {
                        text: 'Поиск клиентов по дате/ месяцу/ году рождения.\n Напомним, что дата выглядит так “01.01.1980” \n (две цифры-точка-две цифры-точка-четыре цифры) \n Поэтому, при поиске части даты, не забудьте про точки! \n Чтобы найти точную дату 01.01.1980, введите в поле “01.01.1980” \n Чтобы найти все даты с “январем 1980 года”, введите в поле ".01.1980” \n Чтобы найти все даты с “1 января”, введите в поле “01.01.” \n Чтобы найти все даты с “январем”, введите в поле “.01.” \n Чтобы найти все даты с “1980 годом”, введите в поле “..1980”',
                      })
                    }
                    src={require(`@/assets/icons/question.svg`)}
                    class="cursor-pointer"
                    width="12"
                    height="12"
                  />
                </div>
                <input
                  ref="birthMaskFilter"
                  type="text"
                  class="tw-app-input-dark tw-app-input-dark-small"
                  placeholder="__.__.____"
                  value={this.filterDateMask}
                  onInput={(e) => this.setBirthDateMaskFilter(e)}
                  style={{ width: "100%" }}
                  inputmode="numeric"
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.clients__fiz_date_birth
                  ? this.$time(row.clients__fiz_date_birth).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "sb_1_days",
          key: "16",
          title: this.dataLang["clients_register_text_111"],
          align: "left",
          width: "4%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "sb_2_days",
          key: "222",
          title: this.dataLang["clients_register_text_112"],
          align: "left",
          width: "4%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "days_without_orders",
          key: "23",
          title: this.dataLang["clients_register_text_113"],
          align: "left",
          width: "4%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "contracts_count",
          key: "24",
          title: this.dataLang["clients_register_text_114"],
          align: "left",
          width: "4%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "payments_total",
          key: "25",
          title: this.dataLang["clients_register_text_115"],
          align: "left",
          width: "6%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.payments_total.length
                  ? row.payments_total.replace(".", ",")
                  : ""}
              </span>
            );
          },
        },
        {
          field: "clients__reting",
          key: "33",
          title: this.dataLang["clients_register_text_116"],
          align: "left",
          width: "3%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <BaseInputNew
                  inputClass="tw-app-input-dark tw-app-input-dark-small"
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"clients__reting"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "clients__next_call_date",
          key: "103",
          title: this.dataLang["clients_register_text_117"],
          align: "left",
          width: "6%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                {/* <div class="tw-hidden">
                  <div class={"text-center"}>{column.title}</div>
                  <BaseInputNew
                    placeholder=""
                    style={"width: 100%"}
                    disabled={false}
                    onInput={this.fillFilter}
                    additionalParams={{ type: "like", mod: "datetimeUTC" }}
                    inputName={"clients__next_call_date"}
                    value={""}
                    nameSign={""}
                  />
                </div> */}
                <div class={"text-center d-flex gap-5 align-items-center"}>
                  {column.title}{" "}
                  <img
                    onClick={() =>
                      this.$modal.show("questionModal", {
                        text: 'Поиск по дате/ месяцу/ году.\n Напомним, что дата выглядит так “01.01.1980” \n (две цифры-точка-две цифры-точка-четыре цифры) \n Поэтому, при поиске части даты, не забудьте про точки! \n Чтобы найти точную дату 01.01.1980, введите в поле “01.01.1980” \n Чтобы найти все даты с “январем 1980 года”, введите в поле ".01.1980” \n Чтобы найти все даты с “1 января”, введите в поле “01.01.” \n Чтобы найти все даты с “январем”, введите в поле “.01.” \n Чтобы найти все даты с “1980 годом”, введите в поле “..1980”',
                      })
                    }
                    src={require(`@/assets/icons/question.svg`)}
                    class="cursor-pointer"
                    width="12"
                    height="12"
                  />
                </div>
                <input
                  ref="clientsNextCallDate"
                  type="text"
                  class="tw-app-input-dark tw-app-input-dark-small"
                  placeholder="__.__.____"
                  value={this.filterDateMaskNextCall}
                  onInput={(e) => this.setClientsNextCallDateMaskFilter(e)}
                  style={{ width: "100%" }}
                  inputmode="numeric"
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.clients__next_call_date
                  ? this.$time(row.clients__next_call_date).format(
                      `${this.userSetting.company__tempalte_date} HH:mm`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "last_comment_text",
          key: "102",
          title: this.dataLang["clients_register_text_118"],
          align: "left",
          width: "15%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "last_comment_date",
          key: "1012",
          title: this.dataLang["clients_register_text_119"],
          align: "left",
          width: "6%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.last_comment_date
                  ? this.$time(row.last_comment_date)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "last_comment_employee",
          key: "101",
          title: this.dataLang["clients_register_text_120"],
          align: "left",
          width: "6%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 19.5px"}></div>

                {/* <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"last_comment_employee"}
                  value={""}
                  nameSign={""}
                /> */}
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
